// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2MDHZ","inputWrap":"CustomTip_inputWrap__1T1by"};